<div class="modal-header d-flex align-items-center px-0 py-3">
    <div class="modal-title f-20">Filters</div>
    <button
      
      style="float: right; cursor: pointer; background: none; border: none"
      aria-hidden="true"
      (click)="resetFilters()"
    >
     <i class="fa fa-times"></i>
    </button>
  </div>
  <div class="modal-body p-0 addassesment-body">
    <div class="col-md-12">
      <div class="row">
        <form [formGroup]="filterForm" style="min-height: 225px" class="w-100">
          <div class="form-group row mt-3">
            <!-- <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                ><lucide-icon name="list-checks" size="16"></lucide-icon>
                Risk Ref</label
              >
              <mat-chip-grid #riskrefInputList>
                <ng-container *ngFor="let riskref of riskfilterRef">
                  <mat-chip-row
                    
                    [removable]="removable"
                    (removed)="removeriskRef(riskref.id)"
                    class="mat-chip-category {{ riskref.classStyle }}"
                  >
                    <lucide-icon
                      *ngIf="riskref.icon != ''"
                      [name]="riskref.icon"
                      size="14"
                    ></lucide-icon>
                    {{ riskref.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #riskRefInput
                  formControlName="riskRef"
                  [formControl]="searchriskrefCntrl"
                  [matAutocomplete]="riskRefAutoComplete"
                  [matChipInputFor]="riskrefInputList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addriskRef($event)"
                  #riskRefAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #riskRefAutoComplete="matAutocomplete"
                (optionSelected)="selectedriskRefEvent($event)"
              >
               
              </mat-autocomplete>
            </div> -->

            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Risk Area</label
              >
              <mat-chip-grid #riskareaInputList>
                <ng-container *ngFor="let riskarea of riskfilterArea">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeriskArea(riskarea.id)"
                    class="mat-chip-category {{ riskarea.classStyle }}"
                  >
                    
                    {{ riskarea.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #riskAreaInput
                  formControlName="riskArea"
                  [formControl]="searchriskAreaCntrl"
                  [matAutocomplete]="riskAreaAutoComplete"
                  [matChipInputFor]="riskareaInputList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addriskArea($event)"
                  #riskAreaAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #riskAreaAutoComplete="matAutocomplete"
                (optionSelected)="selectedriskAreaEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedriskAreaList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                   
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>


            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Risk Category</label
              >
              <mat-chip-grid #riskcategoryInputList>
                <ng-container *ngFor="let riskcategory of riskfilterCategory">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeriskCategory(riskcategory.id)"
                    class="mat-chip-category {{ riskcategory.classStyle }}"
                  >
                   
                    {{ riskcategory.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #riskCategoryInput
                  formControlName="riskCategory"
                  [formControl]="searchriskCategoryCntrl"
                  [matAutocomplete]="riskCategoryAutoComplete"
                  [matChipInputFor]="riskcategoryInputList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addriskCategory($event)"
                  #riskCategoryAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #riskCategoryAutoComplete="matAutocomplete"
                (optionSelected)="selectedriskCategoryEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedriskCategoryList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                   
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Risk Title</label
              >
              <mat-chip-grid #risktitleInputList>
                <ng-container *ngFor="let risktitle of riskfilterTitle">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeriskTitle(risktitle.id)"
                    class="mat-chip-category {{ risktitle.classStyle }}"
                  >
                    
                    {{ risktitle.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #riskTitleInput
                  formControlName="riskTitle"
                  [formControl]="searchriskTitleCntrl"
                  [matAutocomplete]="riskTitleAutoComplete"
                  [matChipInputFor]="risktitleInputList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addriskTitle($event)"
                  #riskTitleAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #riskTitleAutoComplete="matAutocomplete"
                (optionSelected)="selectedriskTitleEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedriskTitleList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                   
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Compliance Topic</label
              >
              <mat-chip-grid #complianceTopicList>
                <ng-container *ngFor="let compliancetopic of compliancefilterTopic">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removecomplianceTopic(compliancetopic.id)"
                    class="mat-chip-category {{ compliancetopic.classStyle }}"
                  >
                    
                    {{ compliancetopic.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #complianceTopicInput
                  formControlName="complianceTopic"
                  [formControl]="searchcomplianceTopicCntrl"
                  [matAutocomplete]="complianceTopicAutoComplete"
                  [matChipInputFor]="complianceTopicList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addcomplianceTopic($event)"
                  #complianceTopicAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #complianceTopicAutoComplete="matAutocomplete"
                (optionSelected)="selectedcomplianceTopicEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedcomplianceTopicList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                   
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Inherent Risk Rating</label
              >
              <mat-chip-grid #inherentRiskRating>
                <ng-container *ngFor="let inherentRiskRating of inherentfilterRiskRatingList">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeinherentRiskRating(inherentRiskRating.id)"
                    class="mat-chip-category {{ inherentRiskRating.classStyle }}"
                  >
                    
                    {{ inherentRiskRating.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #inherentRiskRatingInput
                  formControlName="inherentRiskRating"
                  [formControl]="saerchinherentRiskRatingCntrl"
                  [matAutocomplete]="inherentRiskRatingAutoComplete"
                  [matChipInputFor]="inherentRiskRating"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addinherentRiskRating($event)"
                  #inherentRiskRatingAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #inherentRiskRatingAutoComplete="matAutocomplete"
                (optionSelected)="selectedinherentRiskRatingEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedinherentRiskRatingList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                   
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Residual Risk Rating</label
              >
              <mat-chip-grid #residualRiskRating>
                <ng-container *ngFor="let residualRiskRating of residualfilterRiskRatingList">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeresidualRiskRating(residualRiskRating.id)"
                    class="mat-chip-category {{ residualRiskRating.classStyle }}"
                  >
                    
                    {{ residualRiskRating.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #residualRiskRatingInput
                  formControlName="residualRiskRating"
                  [formControl]="searchresidualRiskRatingCntrl"
                  [matAutocomplete]="residualRiskRatingAutoComplete"
                  [matChipInputFor]="residualRiskRating"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addresidualRiskRating($event)"
                  #residualRiskRatingAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #residualRiskRatingAutoComplete="matAutocomplete"
                (optionSelected)="selectedresidualRiskRatingEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedresidualRiskRatingList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                   
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
            
            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Entities Impacted</label
              >
              <mat-chip-grid #EntitiesImpacted>
                <ng-container *ngFor="let entitiesImpacted of entitiesfilterImpacted">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeentitiesImpacted(entitiesImpacted.id)"
                    class="mat-chip-category {{ entitiesImpacted.classStyle }}"
                  >
                    
                    {{ entitiesImpacted.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #entitiesImpactedInput
                  formControlName="entitiesImpacted"
                  [formControl]="searchentitiesImpactedCntrl"
                  [matAutocomplete]="entitiesImpactedAutoComplete"
                  [matChipInputFor]="EntitiesImpacted"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addentitiesImpacted($event)"
                  #entitiesImpactedAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #entitiesImpactedAutoComplete="matAutocomplete"
                (optionSelected)="selectedentitiesImpactedEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedentitiesImpactedList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                   
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>
            
            <div class="col-lg-12 col-md-12 mb-3">
              <label class="control-label"
                >
                Risk Owner</label
              >
              <mat-chip-grid #RiskOwner>
                <ng-container *ngFor="let riskowner of riskfilterOwner">
                  <mat-chip-row
                    [selectable]="selectable"
                    [removable]="removable"
                    (removed)="removeriskOwner(riskowner.id)"
                    class="mat-chip-category {{ riskowner.classStyle }}"
                  >
                   
                    {{ riskowner.item }}
                    <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                  </mat-chip-row>
                </ng-container>
                <input
                  class="form-control form-control-sm mat-autodd-input border-bottom"
                  #riskOwnerInput
                  formControlName="riskOwner"
                  [formControl]="searchriskOwnerCntrl"
                  [matAutocomplete]="riskOwnerAutoComplete"
                  [matChipInputFor]="RiskOwner"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addriskOwner($event)"
                  #riskOwnerAutoTrigger="matAutocompleteTrigger"
                  placeholder="Type to filter or add new choice"
                />
              </mat-chip-grid>
              <mat-autocomplete
                #riskOwnerAutoComplete="matAutocomplete"
                (optionSelected)="selectedriskOwnerEvent($event)"
              >
                <mat-option
                  *ngFor="let obj of searchedriskOwnerList"
                  [value]="obj.item"
                  class="category_options"
                >
                  <span class="option {{ obj.classStyle }}">
                    
                    {{ obj.item }}
                  </span>
                </mat-option>
              </mat-autocomplete>
            </div>


           
            
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer px-0 py-2">
    <button class="btn bg-g-lightGreen btn-sm" (click)="saveFilters()">
      Search
    </button>
    <button class="btn bg-g-lightGreen btn-sm" (click)="resetFilters()">
      Clear
    </button>
  </div>
  